import { injectToolCSS } from "../utils/cssGenerator";
import IToolConfig from "../types/IToolConfig";

export const stopAnimationsConfig: IToolConfig = {
    id: "stop-animations",
    selector: `html`,
    childrenSelector: ['*'],
    styles: {
        'transition': 'none !important',
        'animation': 'none !important',
        'animation-fill-mode': 'forwards !important',
        'animation-iteration-count': '1 !important',
        'animation-duration': '0.01s !important'
    }
}

export default function stopAnimations(enable=false) {
    injectToolCSS({
        ...stopAnimationsConfig,
        enable
    });
}